import { isDevelopmentEnvironment } from "@/lib/env";

// Desligado: nada muda na tela de Histórico de Pedidos. Ligue (true) junto com a flag do backend para mostrar o
// botão "Integração" (andamento do envio direto do pedido ao ERP).
export const ERP_DIRECT_INTEGRATION_ENABLED = true;

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const ERP_DIRECT_INTEGRATION_DEV_ONLY = true;

export let isErpDirectIntegrationEnabled = false;

// Botão "Integração" e painel de andamento no Histórico de Pedidos.
// Comente a linha abaixo para desativar a funcionalidade no frontend.
// Mantenha em sincronia com Features/ErpDirectIntegrationFeature.cs do backend.
isErpDirectIntegrationEnabled =
  ERP_DIRECT_INTEGRATION_ENABLED && (!ERP_DIRECT_INTEGRATION_DEV_ONLY || isDevelopmentEnvironment);
